/* eslint-disable */
import { takeLatest, takeEvery, all } from 'redux-saga/effects'
import API from '../Services/Api'
import FixtureAPI from '../Services/FixtureApi'
import DebugConfig from '../Config/DebugConfig'

/* ------------- Types ------------- */

import { StartupTypes } from '../Redux/StartupRedux'
// import { GithubTypes } from '../Redux/GithubRedux'
import { AuthTypes } from '../Redux/AuthRedux'
import { SignUpTypes } from '../Redux/SignUpRedux'
import { UserTypes } from '../Redux/UserRedux'
import { PaypalTypes } from '../Redux/PaypalRedux'
import { FollowTypes } from '../Redux/FollowRedux'
import { PostsTypes } from '../Redux/PostsRedux'
import { WhoFollowTypes } from '../Redux/WhoFollowRedux'
import { HappeningsTypes } from '../Redux/HappeningsRedux'
import { ReloginTypes } from '../Redux/ReloginRedux'
import { MessagesTypes } from '../Redux/MessagesRedux'
import { GetFollowTypes } from '../Redux/GetFollowRedux'
import { PostPeopleTypes } from '../Redux/PostPeopleRedux'
import { UserPopularTypes } from '../Redux/UserPopularRedux'
import { KargoeTagTypes } from '../Redux/KargoeTagRedux'
import { KargoeSearchTagTypes } from '../Redux/KargoeSearchTagRedux'
import { ItemTypes } from '../Redux/ItemRedux'
import { KargoeCareTypes } from '../Redux/KargoeCareRedux'
import { PostDetailsTypes } from '../Redux/PostDetails2Redux'
import { CreatePostTypes } from '../Redux/CreatePostRedux'
import { OrderTypes } from '../Redux/OrderRedux'
import { LoveTypes } from '../Redux/LoveRedux'
import { ShareTypes } from '../Redux/ShareRedux'
import { ShoppableTypes } from '../Redux/ShoppableRedux'
import { CouponTypes } from '../Redux/CouponRedux'
import { AppleMusicTypes } from '../Redux/AppleMusicRedux'

/* ------------- Sagas ------------- */

import { startup } from './StartupSagas'
// import { getUserAvatar } from './GithubSagas'
import { getGroup, groupAddUser, groupRemoveUser, switchToGroupUser, addProfile, cancelAddProfile, loginUser, logoutUser, renewToken, updateKargoePassword,
    loginFacebook,signupFacebook, setMode, changePassword, nonSagaLogin, signup, updateAuthUser } from './AuthSagas'
// import { signUpUser } from './SignUpSaga'
import { readUser, readOtherUser, updateUser, setPushFlags, updateTouchId, updateKargoeCare
    , resetPass ,blockUser, addAddress, getBlockUser, outofdate, listFollowing, listFollowers, getExchangeRates, setUserDefaultCurrency } from './UserSagas'

import { paypalStatus, paypalLogout } from './PaypalSagas'
import { followUser, unfollowUser } from './FollowSagas'
import { whoFollowMe } from './WhoFollowSagas'
import { kargoeHappening } from './HappeningsSagas'
import {
    getPosts, getPostsItem, getLikePost,
    searchTagPost, readPost, postTagDetail, getPostAllLikes,
    getPostComments, postComment, searchUser,
    deleteComment, createStandardPost,updatePost,repost,readMultiPost,
     deletePost, reportPost, sendOneFrame,deleteHashTag
} from './PostsSagas'
import { getRelogin } from './ReloginSagas'
import { getMessages, getChat, chatSend, getUnreadMessages, deleteChat, updateChatState, chatStopTyping, markChatRead } from './MessagesSagas'
import { getGetFollow } from './GetFollowSagas'
import { getPostPeople, getUsers, getUserPosts } from './PostPeopleSagas'
import { getPopularUsers } from './UserPopularSagas'
import { getKargoeTag, getSearchTag, searchItems } from './KargoeTagSagas'
import { getItem } from './ItemSagas'
import { getKargoeCare } from './KargoeCareSagas'
import { readPosts } from './PostDetails2Sagas'
import { createPost, createRepost, createOptions } from './CreatePostSagas'
import { tagDetails, preflightOrder, confirmOrder, purchaseOrder ,purchaseSagaOrder} from './OrderSagas'
import { quickLove, lovePost, unlovePost } from './LoveSagas'
import { getOrderEndorse ,getOrderBought,getOrderSold,getOrderDetail,shipOrder} from './OrderSagas'
import { getFacebookStatus} from './ShareSagas'
import { shoppableGetConfig, shoppableSearchItems, shoppableGetItems, shoppableGetVariants, shoppableCreateCartWithItem, shoppableSetCheckoutUrl } from './ShoppableSagas'
import { userCoupons, getOffer, redeemCoupon, vendorOffers, getVendor, allOffers } from './CouponSagas'
import { search } from './AppleMusicSagas'



/* ------------- API ------------- */

// The API we use is only used from Sagas, so we create it here and pass along
// to the sagas which need it.
const api = DebugConfig.useFixtures ? FixtureAPI : API.create()

/* ------------- Connect Types To Sagas ------------- */

const rootSaga = function* root() {
    yield all([
        // some sagas only receive an action
        takeLatest(StartupTypes.STARTUP, startup),
//        takeEvery(SignUpTypes.SIGNUP_REQUEST, signUpUser, api),
        takeLatest(ReloginTypes.RELOGIN_REQUEST, getRelogin, api),
        takeLatest(MessagesTypes.MESSAGES_REQUEST, getMessages, api),
        takeLatest(MessagesTypes.DELETE_CHAT_REQUEST, deleteChat, api),
        takeLatest(MessagesTypes.CHAT_HAVE_READ, markChatRead, api),
        takeLatest(UserTypes.OUTOFDATE, outofdate, api),

				takeEvery(AuthTypes.GET_GROUP_REQUEST, getGroup, api),
				takeEvery(AuthTypes.GROUP_ADD_USER_REQUEST, groupAddUser, api),
				takeEvery(AuthTypes.GROUP_REMOVE_USER_REQUEST, groupRemoveUser, api),
				takeEvery(AuthTypes.GROUP_SWITCH_USER_REQUEST, switchToGroupUser, api),
				takeEvery(AuthTypes.ADD_PROFILE_REQUEST, addProfile, api),
				takeEvery(AuthTypes.CANCEL_ADD_PROFILE_REQUEST, cancelAddProfile, api),

        takeEvery(AuthTypes.RENEW_TOKEN, renewToken, api),
        takeEvery(AuthTypes.AUTH_REQUEST, loginUser, api),
        takeEvery(AuthTypes.AUTH_SUCCESS, nonSagaLogin, api),
        takeEvery(AuthTypes.AUTH_MODE, setMode, api),
        // takeLatest(AuthTypes.AUTH_UPDATE_REQUEST, updateAuthUser, api), // not necessary as we are just changing the store
        takeEvery(AuthTypes.CHANGE_PASSWORD, changePassword, api),
        takeEvery(AuthTypes.FACEBOOK_LOGIN_REQUEST, loginFacebook, api),
        takeEvery(AuthTypes.FACEBOOK_SIGNUP_REQUEST, signupFacebook, api),
        takeEvery(AuthTypes.KARGOE_PASSWORD_REQUEST, updateKargoePassword, api),
        takeEvery(AuthTypes.SIGNUP_REQUEST, signup, api),
        takeLatest(AuthTypes.LOGOUT_REQUEST, logoutUser, api),

        takeEvery(PaypalTypes.PAYPAL_STATUS_REQUEST, paypalStatus, api),
        takeLatest(PaypalTypes.PAYPAL_LOGOUT_REQUEST, paypalLogout, api),
        // some sagas receive extra parameters in addition to an action
//        takeLatest(GithubTypes.USER_REQUEST, getUserAvatar, api),
        takeEvery(UserTypes.RESET_PASS_REQUEST, resetPass, api),
        takeEvery(UserTypes.READ_REQUEST, readUser, api),
        takeEvery(UserTypes.READ_OTHER_REQUEST, readOtherUser, api),
        takeEvery(UserTypes.UPDATE_REQUEST, updateUser, api),
        takeEvery(UserTypes.SET_PUSH_FLAGS, setPushFlags, api),
        takeEvery(UserTypes.UPDATE_TOUCH_ID_REQUEST, updateTouchId, api),
        takeEvery(UserTypes.UPDATE_KARGOE_CARE_REQUEST, updateKargoeCare, api),
        takeEvery(KargoeCareTypes.KARGOE_CARE_REQUEST, getKargoeCare, api),

        takeEvery(UserTypes.ADD_ADDRESS_REQUEST, addAddress, api),
        takeEvery(UserTypes.BLOCK_USER_REQUEST, blockUser, api),
        takeEvery(UserTypes.GET_BLOCK_USER_REQUEST, getBlockUser, api),
        takeEvery(WhoFollowTypes.WHO_FOLLOW_ME_REQUEST, whoFollowMe, api),
        takeEvery(HappeningsTypes.KARGOE_REQUEST, kargoeHappening, api),
        takeEvery(FollowTypes.FOLLOW_REQUEST, followUser, api),
        takeEvery(FollowTypes.UNFOLLOW_REQUEST, unfollowUser, api),
        takeEvery(GetFollowTypes.GET_FOLLOW_REQUEST, getGetFollow, api),
        takeEvery(UserTypes.LIST_FOLLOWING_REQUEST, listFollowing, api),
        takeLatest(UserTypes.LIST_FOLLOWERS_REQUEST, listFollowers, api),
        takeEvery(UserTypes.GET_EXCHANGE_RATES, getExchangeRates, api),
        takeEvery(UserTypes.SET_USER_DEFAULT_CURRENCY, setUserDefaultCurrency, api),
        takeEvery(PostPeopleTypes.POST_PEOPLE_REQUEST, getPostPeople, api),
        takeEvery(PostPeopleTypes.POST_PEOPLE_REQUEST2, getUsers, api),
        takeEvery(PostPeopleTypes.POST_PEOPLE_POST_REQUEST, getUserPosts, api),
        takeEvery(UserPopularTypes.USER_POPULAR_REQUEST, getPopularUsers, api),
        takeEvery(KargoeTagTypes.KARGOE_TAG_REQUEST, getKargoeTag, api),
        takeEvery(KargoeTagTypes.KARGOE_TAG_SEARCH_REQUEST, getSearchTag, api),
        takeEvery(KargoeTagTypes.KARGOE_SEARCH_ITEMS_REQUEST, searchItems, api),
        takeEvery(PostsTypes.POSTS_REQUEST, getPosts, api),
        takeEvery(PostsTypes.DELETE_POST_REQUEST, deletePost, api),
        takeEvery(PostsTypes.POSTS_ITEM_REQUEST, getPostsItem, api),
        takeEvery(PostsTypes.POSTS_LIKE_REQUEST, getLikePost, api),
        takeEvery(PostsTypes.POSTS_TAG_REQUEST, searchTagPost, api),
        takeEvery(PostsTypes.DELETE_HASH_TAG_REQUEST, deleteHashTag, api),
        takeLatest(PostsTypes.GET_POST_ALL_LIKES_REQUEST, getPostAllLikes, api),
        takeEvery(PostsTypes.GET_POST_COMMENTS_REQUEST, getPostComments, api),
        takeEvery(PostsTypes.POST_COMMENT_REQUEST, postComment, api),
        takeEvery(PostsTypes.DELETE_COMMENT_REQUEST, deleteComment, api),
        takeEvery(PostsTypes.CREATE_STANDARD_POST_REQUEST, createStandardPost, api),
        takeEvery(PostsTypes.REPORT_POST_REQUEST, reportPost, api),
        takeLatest(PostsTypes.SEARCH_USER_REQUEST, searchUser, api),

        takeEvery(PostsTypes.READ_POST_REQUEST, readPost, api),
        takeEvery(PostsTypes.REPOST_REQUEST, repost, api),
        takeEvery(PostsTypes.READ_MULTI_POST_REQUEST, readMultiPost, api),
        takeEvery(PostsTypes.UPDATE_POST_REQUEST, updatePost, api),
        takeEvery(PostsTypes.POST_TAG_DETAIL_REQUEST, postTagDetail, api),
        takeEvery(ItemTypes.ITEM_REQUEST, getItem, api),

        takeEvery(MessagesTypes.UPDATE_CHAT_STATE, updateChatState, api),
        takeEvery(MessagesTypes.CHAT_REQUEST, getChat, api),
        takeEvery(MessagesTypes.GET_UNREAD_MESSAGES_REQUEST, getUnreadMessages, api),
        takeEvery(MessagesTypes.CHAT_SEND_REQUEST, chatSend, api),

        takeEvery(PostDetailsTypes.POSTS2_REQUEST, readPosts, api),

        takeEvery(CreatePostTypes.CREATE_REQUEST, createPost, api),
        takeEvery(CreatePostTypes.CREATE_REPOST, createRepost, api),
        takeEvery(CreatePostTypes.CREATE_OPTIONS, createOptions, api),

        takeEvery(LoveTypes.LOVE_INSIST, quickLove, api),
        takeEvery(LoveTypes.LOVE_REQUEST, lovePost, api),
        takeEvery(LoveTypes.UNLOVE_REQUEST, unlovePost, api),

        takeEvery(OrderTypes.ORDER_TAGS, tagDetails, api),
        takeEvery(OrderTypes.ORDER_PREFLIGHT, preflightOrder, api),
        takeEvery(OrderTypes.ORDER_CONFIRM, confirmOrder, api),
        takeEvery(OrderTypes.ORDER_PURCHASE, purchaseOrder, api),
        takeEvery(OrderTypes.ORDER_PURCHASE_REQUEST, purchaseSagaOrder, api),

        takeEvery(OrderTypes.ORDER_ENDORSE_REQUEST, getOrderEndorse, api),
        takeEvery(OrderTypes.ORDER_BOUGHT_REQUEST, getOrderBought, api),
        takeEvery(OrderTypes.ORDER_SOLD_REQUEST, getOrderSold, api),
        takeEvery(OrderTypes.ORDER_DETAIL_REQUEST, getOrderDetail, api),
        takeEvery(OrderTypes.ORDER_SHIP_REQUEST, shipOrder, api),
        takeEvery(ShareTypes.GET_FACEBOOK_REQUEST, getFacebookStatus, api),

        takeEvery(ShoppableTypes.SHOP_GET_CONFIG, shoppableGetConfig, api),  // cancel previous
        takeEvery(ShoppableTypes.SHOP_SEARCH_ITEMS, shoppableSearchItems, api),
        takeEvery(ShoppableTypes.SHOP_GET_ITEMS, shoppableGetItems, api),
        takeEvery(ShoppableTypes.SHOP_GET_VARIANTS, shoppableGetVariants, api),
        takeEvery(ShoppableTypes.SHOP_CREATE_CART_WITH_ITEM, shoppableCreateCartWithItem, api),
        takeEvery(ShoppableTypes.SHOP_SET_CHECKOUT_URL, shoppableSetCheckoutUrl, api),

        takeEvery(CouponTypes.USER_COUPONS, userCoupons, api),
        takeEvery(CouponTypes.REDEEM_COUPON, redeemCoupon, api),
        takeEvery(CouponTypes.GET_OFFER, getOffer, api),
        takeEvery(CouponTypes.VENDOR_OFFERS, vendorOffers, api),
        takeEvery(CouponTypes.GET_VENDOR, getVendor, api),
        takeEvery(CouponTypes.ALL_OFFERS, allOffers, api),

        takeEvery(AppleMusicTypes.SEARCH_REQUEST, search, api),
    ])
}
export default rootSaga;
export { api as api }
